module.exports = __webpack_public_path__ + "static/logo_yonglin_footer_mobile-53f00c6eda426e4249726f9afcd5266a.png";